import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './index.module.css';
import { useTranslation } from 'react-i18next';

const Anchor = ({ className, href, text, ...props }) => {
  const { t } = useTranslation();
  return (
    <a className={cn(styles.policyLink, className)} href={href} {...props}>
      {t(text)}
    </a>
  );
};

Anchor.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};
export default Anchor;
